/* OOO Advertorial LP — section-scoped interactivity
   Foundation contracts:
   - Scroll reveal handled by ooo-motion.js (global). We only
     wire the [data-ooo-stagger] auto-stagger here (mirror of
     source script.js § 1) for timeline cards.
   - Subscribe/one-time toggle (§ 2 equivalent).
   - Buy box thumbnail gallery (replaces static carousel § 3).
   - ooo-cart.js intercepts form[action*="/cart/add"] globally.
*/

(function () {
  'use strict';

  /* ── 1. Auto-stagger for timeline grid ────────────────── */
  document.querySelectorAll('[data-ooo-stagger]').forEach(function (parent) {
    Array.from(parent.children).forEach(function (child, i) {
      if (!child.classList.contains('ooo-reveal')) {
        child.classList.add('ooo-reveal');
      }
      child.style.setProperty('--ooo-reveal-delay', (i * 90) + 'ms');
    });
  });

  /* ── 2. Subscribe / one-time purchase toggle (+ SKIO selling plan) ── */
  document.querySelectorAll('[data-ooo-pcard]').forEach(function (card) {
    var opts = card.querySelectorAll('[data-ooo-opt]');
    var form = (card.parentElement && card.parentElement.querySelector('.ooo-adv__atc-form'))
               || document.querySelector('.ooo-adv__atc-form');
    var sp = form ? form.querySelector('[data-ooo-adv-sp]') : null;
    var planId = sp ? String(sp.value || '').trim() : '';
    function apply(opt) {
      opts.forEach(function (o) { o.classList.remove('is-active'); });
      opt.classList.add('is-active');
      /* subscribe -> pass the SKIO plan; one-time (or no plan) -> drop it */
      if (sp) sp.disabled = (opt.getAttribute('data-mode') !== 'sub') || !planId;
    }
    opts.forEach(function (opt) {
      opt.addEventListener('click', function () { apply(opt); });
    });
    var init = card.querySelector('[data-ooo-opt].is-active') || opts[0];
    if (init) apply(init);
  });

  /* ── 3. Buy box thumbnail gallery ────────────────────── */
  document.querySelectorAll('[data-ooo-thumbs]').forEach(function (thumbsEl) {
    var thumbBtns = thumbsEl.querySelectorAll('[data-ooo-thumb]');
    var heroImg = thumbsEl.closest('.ooo-adv__buy-media')
                          && thumbsEl.closest('.ooo-adv__buy-media').querySelector('.ooo-adv__buy-hero');
    var prevBtn = thumbsEl.querySelector('[data-ooo-prev]');
    var nextBtn = thumbsEl.querySelector('[data-ooo-next]');
    var current = 0;

    // Collect src list from thumb images
    var srcs = [];
    thumbBtns.forEach(function (btn) {
      var img = btn.querySelector('img');
      if (img) { srcs.push(img.src); }
    });

    function goTo(idx) {
      if (!thumbBtns.length) return;
      current = (idx + thumbBtns.length) % thumbBtns.length;
      thumbBtns.forEach(function (b, i) {
        b.classList.toggle('is-active', i === current);
      });
      // Swap main hero src if we have a valid src
      if (heroImg && srcs[current]) {
        heroImg.src = srcs[current];
      }
    }

    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(parseInt(btn.dataset.oooThumb, 10));
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goTo(current - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goTo(current + 1); });
    }
  });

})();
